/**
 * Mocked events for the explore-page mockups. Mix of all event types
 * so the Events block can demonstrate the multi-type-in-one-place
 * pitch: tournaments aren't a separate product, they sit next to
 * gaming sessions, meetups, and streams in the same feed.
 */

export type MockEventType = 'TOURNAMENT' | 'GAMING_SESSION' | 'MEETUP' | 'STREAM'

export type MockEvent = {
  id: string
  type: MockEventType
  title: string
  startsAt: string
  endsAt: string
  gameName: string | null
  attendeeCount: number
  attendeeCap: number | null
  isPaid?: boolean
  prizePoolPence?: number
  entryFeePence?: number
  venueName?: string | null
  isOnline?: boolean
  streamPlatform?: string | null
  hostCallsign: string
  recurring?: boolean
}

const NOW_ISO = '2026-06-16T20:00:00Z'
const HOURS_FROM_NOW = (h: number): string =>
  new Date(Date.parse(NOW_ISO) + h * 3_600_000).toISOString()
const DAYS_FROM_NOW = (d: number): string =>
  new Date(Date.parse(NOW_ISO) + d * 86_400_000).toISOString()

export const MOCK_EVENTS: MockEvent[] = [
  {
    id: 'evt-cs2-bracket',
    type: 'TOURNAMENT',
    title: 'Friday Bracket Night · CS2',
    startsAt: DAYS_FROM_NOW(2),
    endsAt: DAYS_FROM_NOW(2.2),
    gameName: 'Counter-Strike 2',
    attendeeCount: 12,
    attendeeCap: 16,
    isPaid: true,
    prizePoolPence: 8_000,         // £80 pot
    entryFeePence: 500,            // £5 entry
    isOnline: true,
    hostCallsign: '@halcyon',
  },
  {
    id: 'evt-apex-session',
    type: 'GAMING_SESSION',
    title: 'Apex Squad — Ranked Push',
    startsAt: HOURS_FROM_NOW(2),
    endsAt: HOURS_FROM_NOW(5),
    gameName: 'Apex Legends',
    attendeeCount: 5,
    attendeeCap: 6,
    isOnline: true,
    hostCallsign: '@stormbreaker',
    recurring: true,
  },
  {
    id: 'evt-london-pub',
    type: 'MEETUP',
    title: 'London Pub Meet · Q3',
    startsAt: DAYS_FROM_NOW(9),
    endsAt: DAYS_FROM_NOW(9.3),
    gameName: null,
    attendeeCount: 14,
    attendeeCap: 20,
    isOnline: false,
    venueName: 'The Devereux, Temple WC2R',
    hostCallsign: '@halcyon',
  },
  {
    id: 'evt-orion-stream',
    type: 'STREAM',
    title: 'Orion · Tactical FPS night',
    startsAt: HOURS_FROM_NOW(1),
    endsAt: HOURS_FROM_NOW(4),
    gameName: 'Valorant',
    attendeeCount: 0,
    attendeeCap: null,
    streamPlatform: 'Twitch',
    hostCallsign: '@orion',
  },
  {
    id: 'evt-rocket-league',
    type: 'TOURNAMENT',
    title: 'Sunday RL 2v2 Cup',
    startsAt: DAYS_FROM_NOW(4),
    endsAt: DAYS_FROM_NOW(4.25),
    gameName: 'Rocket League',
    attendeeCount: 8,
    attendeeCap: 8,
    isPaid: false,
    isOnline: true,
    hostCallsign: '@vega',
  },
  {
    id: 'evt-weekly-cs2',
    type: 'GAMING_SESSION',
    title: 'Tuesday CS2 Premier Climb',
    startsAt: DAYS_FROM_NOW(6),
    endsAt: DAYS_FROM_NOW(6.15),
    gameName: 'Counter-Strike 2',
    attendeeCount: 7,
    attendeeCap: 10,
    isOnline: true,
    hostCallsign: '@orion',
    recurring: true,
  },
]
